// Module
var code = "<div class=bible> <h2 class=passageref>Galatians 5.1</h2> <div class=bibletext> <p> <span class=rr>5</span><sup class=ww>1</sup>For freedom Christ has set us free. Stand firm, therefore, and do not submit again to a yoke of slavery. </p> </div></div>";
// Exports
module.exports = code;